import { listCreditPacks } from '@/config/pricing';
import { apiUpload } from '@/lib/api-client';
import { downscaleImage } from '@/lib/image-resize';

/** The cheapest pack sets the "≈ $" price shown under a generate button. */
export const ENTRY_PACK = [...listCreditPacks()].sort((a, b) => a.priceInCents - b.priceInCents)[0];

/** Downscale and upload one studio photo; resolves to its public URL. */
export async function uploadToolPhoto(file: File): Promise<string> {
  const body = new FormData();
  body.append('files', await downscaleImage(file));
  const result = await apiUpload<{ urls: string[] }>('/api/storage/upload-image', body);
  const url = result?.urls?.[0];
  if (!url) throw new Error('upload_failed');
  return url;
}
